<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <div class="currency_boxs confirm_box">
      <div class="order_info">
        <div class="card_box"
             v-if="$route.query.type == 'card'">
          <div class="font20 title">会员卡类型</div>
          <div class="flexStart"
               style="margin:20px 0">
            <el-radio-group v-model="dqCardId"
                            @change="cardChange"
                            size="small">
              <el-radio :label="item.id"
                        v-for="(item,index) in cardList"
                        :key="index"
                        border>{{item.name}}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="font20 title">确认订单信息</div>
        <div class="info">
          <div class="info_title font16">购买订单信息</div>
          <div class="flexStart">
            <div class="left">
              <el-image style="width:186px; height: 108px;"
                        :src="type=='card'?itemData.url:itemData.bannerUrl"></el-image>
              <div style="flex:1;margin-left:20px;color: #666666;">
                <div class="font18"
                     style="color:#333;position: absolute;top: 20px;left: 226px;">{{type =='card'?itemData.name:itemData.activityName}}</div>
                <div class="font16"
                     v-if="type=='order' && itemData.endTimeShort">活动时间：{{itemData.startTimeShort + '至' + itemData.endTimeShort}}</div>
                <div class="font16"
                     v-if="type=='order' && itemData.courseClassify == '1'">活动地点：{{itemData.areaStr}}</div>
              </div>
            </div>
            <div v-if="type=='card'"
                 class="right font20">￥{{itemData.price}}</div>
          </div>
        </div>

        <div class="title font20"
             v-if="type=='order'">请输入报名信息</div>

        <div class="form"
             v-if="type=='order'">
          <el-form :model="formData">
            <el-row>
              <el-col :span="12">
                <el-form-item>
                  <el-select v-model="formData.enterpriseId"
                             filterable
                             @change="enterpriseIdChange"
                             placeholder="请选择企业"
                             style="width:85%;">
                    <el-option v-for="item in enterpriseList"
                               :key="item.enterpriseId"
                               :label="item.enterpriseName"
                               :value="item.enterpriseId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12"
                      v-if="formData.enterpriseId">
                <el-form-item>
                  <div class="username">
                    <i class="el-icon-user-solid font16"></i>
                    <span class="font16">{{formData.username}}</span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="formData.enterpriseId && !isPersonnel">
              <el-col :span="12">
                <el-form-item>
                  <el-input placeholder="手机号"
                            clearable
                            disabled
                            style="width:85%"
                            prefix-icon="el-icon-circle-check"
                            v-model="formData.mobile">
                    <template slot="append"><span @click="getCode()">{{vcodeBtnName}}</span></template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item>
                  <el-input placeholder="验证码"
                            clearable
                            maxlength="6"
                            style="width:85%"
                            v-model="formData.code">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="flexCenter"
                 v-if="formData.enterpriseId && !isPersonnel">
              <el-button type="danger"
                         @click="check">申请报名</el-button>
            </div>
          </el-form>
        </div>

        <div class="title font20"
             v-if="formData.enterpriseId && isPersonnel">企业学习人员</div>

        <div class="personnel"
             v-if="formData.enterpriseId && isPersonnel">
          <div class="left">
            <div class="top flexStart">
              <div class="top_title">企业人员（{{total}}）</div>
              <!-- <div class="btn"
                   @click="add">新增人员</div> -->
            </div>
            <div class="content_box">
              <div style="margin: 15px 0;">
                <el-input placeholder="请输入名称关键字"
                          v-model="empName"
                          class="input-with-select">
                  <i slot="prefix"
                     class="el-input__icon el-icon-search"></i>
                  <el-button slot="append"
                             icon="el-icon-search"></el-button>
                </el-input>
              </div>
              <div class="personnel_box">
                <div class="personnel_item"
                     @mouseenter="mouseover('left',item.userId)"
                     :style="{'border':leftIndex == item.userId?'1px solid #FF0B0B':'','color':leftIndex == item.userId ?'#FF0B0B':''}"
                     @mouseleave="mouseout('left')"
                     @click="itemClick('left',item.userId)"
                     v-for="(item,index) in  empName&&empName!=''?person:personnelList"
                     :key="index">
                  {{item.empName}}

                  <span v-if="leftIndex== item.userId">
                    <i class="el-icon-arrow-right"></i>
                    <i class="el-icon-arrow-right"></i>
                  </span>

                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="top flexStart">
              <div class="top_title">参会人员（{{pendingList.length}}）</div>
            </div>
            <div class="content_box">
              <div class="personnel_box">
                <div class="personnel_item"
                     @mouseenter="mouseover('right',item.userId)"
                     @mouseleave="mouseout('right')"
                     @click="itemClick('right',item.userId)"
                     :style="{'border':rightIndex == item.userId && item.isRegistered != 1 ?'1px solid #FF0B0B':'','color':rightIndex == item.userId  && item.isRegistered != 1 ?'#FF0B0B':''}"
                     v-for="(item,index) in pendingList"
                     :key="index">
                  <span v-if="rightIndex== item.userId && item.isRegistered != 1">
                    <i class="el-icon-arrow-left"></i>
                    <i class="el-icon-arrow-left"></i>
                  </span>
                  {{item.empName}}
                  <span v-if="item.isRegistered == 1"><i class="el-icon-circle-check mainColor"></i></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="font20 title"
             v-if="formData.enterpriseId && isPersonnel">结算信息</div>
        <div class="info"
             v-if="formData.enterpriseId && isPersonnel">
          <div class="info_title font16">请确认本次优惠信息</div>
          <div class="flexStart">
            <div class="left">

              <div class="info_box">
                <div class="info_box_title">享受权益</div>
                <div class="emp">
                  <div>本次参会人员：{{pendingList.length}}人 <span v-if="isRegisteredNum>0">(含{{isRegisteredNum}}人已报名)</span> <span v-if="userMemberCard.rightAvailableCount && userMemberCard.rightAvailableCount>0">({{userMemberCard.rightAvailableCount}}人可免费报名)</span> </div>
                  <div style="margin-left:60px">活动费用：{{userMemberCard.discountPrice}}元/人</div>
                  <div style="margin-left:60px"
                       v-if="userMemberCard.otherFeeName && userMemberCard.otherFeeName!=''">{{userMemberCard.otherFeeName}}：{{userMemberCard.otherFee}}元/人</div>

                </div>
                <div>总额：¥{{(pendingList.length - isRegisteredNum ) * (userMemberCard.otherFee + userMemberCard.discountPrice) }} </div>
              </div>

            </div>
          </div>
        </div>
        <!-- <div class="font20 title">支付方式</div>

        <div>
          <div>微信支付</div>
        </div> -->
      </div>
      <!--  -->
      <div class="bottom"
           v-if="isPayBtn">
        <div class="flexStart">
          <div class="font16"
               v-if="type == 'order'"
               style="color:#666666">
            <div class="mainColor price">总价应付：￥{{payPrice}}</div>
            <div>请确认企业报名并核对支付金额</div>
          </div>
          <div style="flex:1"
               class="flexEnd">
            <div class="font20 price"
                 v-if="type=='card'">应支付：￥{{itemData.price}}</div>
            <el-button type="danger"
                       @click="subPay">立即支付</el-button>
          </div>
        </div>

      </div>
    </div>
    <WechatPay ref="WechatPay"
               v-if="isWechatPay"
               @wechatPaySuccess="wechatPaySuccess"
               @orderStatusClose="orderStatusClose"
               @close="closeModal"></WechatPay>

    <!-- 活动新增企业人员  -->
    <!-- <el-dialog title="新增员工"
               :width="30"
               :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="手机号"
                      :label-width="formLabelWidth">
          <el-input v-model="form.mobile"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="员工姓名"
                      :label-width="formLabelWidth">
          <el-input v-model="form.empName"
                    autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别"
                      :label-width="formLabelWidth">
          <el-select v-model="form.region"
                     placeholder="请选择性别">
            <el-option label="男"
                       value="0"></el-option>
            <el-option label="女"
                       value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门"
                      :label-width="formLabelWidth">
          <el-tree :props="{label:'depName',children:'children'}"
                   :data="treeList"
                   node-key="id"
                   show-checkbox
                   @check-change="handleCheckChange">
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import {
  platformVip, registrationOrder, listByActivity, sendSmsCode, confirmSubmit, listByActivityAndEnterpriseId, selectEnterpriseAdmin, selectMyEnterprise, buyPlatformVip, payPlatformVip, activityInfo, saveNrUser, userInfo_byMobile, getAllDepByOwnerId
} from '@/api/api.js'
import curriculumItem from '@/components/OnlineBusinessSchool/curriculum_item.vue'
import WechatPay from '@/components/WechatPay.vue'
export default {
  components: { curriculumItem, WechatPay },
  data () {
    return {
      empName: '',
      form: { enterpriseId: '', empName: '', mobile: '', sex: '', depId: '' },
      formLabelWidth: 90,
      leftIndex: -1,
      rightIndex: -1,
      formData: {
        activityId: "",
        mobile: '',
        code: '',
        enterpriseId: "",
        username: '',
        registrationDetailList: []
      },
      vcodeBtnName: '获取验证码',
      countNum: 120,
      countDownTimer: null,
      enterpriseList: [],
      personnelList: [],
      person: [],
      userMemberCard: {}, //权益
      isRegisteredNum: 0, // 已报名人数
      total: 0,
      pendingList: [],
      type: 'card',
      itemData: {},
      dqCardId: '',
      cardList: [],
      isWechatPay: false,
      isPayBtn: false,
      isPersonnel: false,
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
      treeList: [],
      payPrice: 0.00,
      clickNum: 0,
      dialogFormVisible: false,
    }
  },
  watch: {
    empName (val) {
      console.log(this.personnelList)
      this.person = this.personnelList.filter((p) => {
        return p.empName.indexOf(val) !== -1
      })
    },
    pendingList (val) {
      if (val.length == 0) {
        this.payPrice = 0.00
      } else {
        if (val.length - this.isRegisteredNum == 0) {
          this.payPrice = 0.00
        } else {
          let num = val.length - this.isRegisteredNum - this.userMemberCard.rightAvailableCount
          if (num <= 0) {
            this.payPrice = 0.00
          } else {
            this.payPrice = num * (this.userMemberCard.otherFee + this.userMemberCard.discountPrice)
          }
        }
      }
    }
  },
  created () {
    if (this.$route.query.type) {
      if (this.$route.query.type == 'card') {
        this.type = 'card'
        this.isPayBtn = true;
        this.getCardList()
      } else if (this.$route.query.type == 'order') {
        this.type = 'order'
        this.isPayBtn = false;
        this.getactivityInfo(this.$route.query.id)
        this.getselectMyEnterprise()
      }
    }
  },
  filters: {

  },
  methods: {
    closeModal () {
      this.isWechatPay = false;
      this.clickNum = 0;
      window.location.reload()
    },
    handleCheckChange (data, checked, indeterminate) {
      console.log(data, checked, indeterminate)
    },
    async add () {
      let data = {
        enterpriseId: this.formData.enterpriseId
      }
      const res = await getAllDepByOwnerId(data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      this.treeList = res.result[0].children;
      this.dialogFormVisible = true
      // this.initData(this.treeList)
    },
    // initData (list) {
    //   list.forEach((item) => {
    //     item['label'] = item.depName
    //     if (item.children && item.children.length != 0) {
    //       this.initData(item.children)
    //     }
    //   })
    //   console.log(this.treeList)
    //   this.dialogFormVisible = true
    // },
    async check () {  //校验
      let data = {
        mobile: this.formData.mobile,
        smsCode: this.formData.code,
        enterpriseId: this.formData.enterpriseId
      }
      this.clickNum = 0;
      const res = await confirmSubmit(data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      if (res && res.code == 200) {
        this.getlistByActivityAndEnterpriseId()
      }
    },
    mouseover (type, index) {  //鼠标经过
      if (type == 'left') {
        this.leftIndex = index;
      } else {
        this.rightIndex = index;
      }
      this.clickNum = 0;
    },
    mouseout (type) {
      if (type == 'left') {
        this.leftIndex = -1;
      } else {
        this.rightIndex = -1;
      }
    },
    itemClick (type, userId) {  //点击人员
      if (type == 'left' && userId == this.leftIndex) {
        this.personnelList.forEach((item, index) => {
          if (item.userId == userId) {
            this.pendingList.push(item)
            this.personnelList.splice(index, 1)
          }
        })
        if (this.empName && this.empName != '' && this.person && this.person.length != 0) {
          this.person.forEach((item, index) => {
            if (item.userId == userId) {
              // this.pendingList.push(item)
              this.person.splice(index, 1)
            }
          })
          // this.person.splice(index, 1)
        }
      } else if (type == 'right' && userId == this.rightIndex) {
        this.empName = '';
        this.pendingList.forEach((item, index) => {
          if (item.userId == userId && item.isRegistered != 1) {
            this.personnelList.push(item)
            this.pendingList.splice(index, 1)
          }
        })
      }
    },
    async getCode () {
      if (this.vcodeBtnName != '获取验证码' && this.vcodeBtnName != '重新发送') {
        return false
      }
      const res = await sendSmsCode(this.formData.mobile)
      if (res && (res.code == 200 || res.code == 0)) {
        this.$message({
          showClose: true,
          message: '短信已发送，请注意查收',
          type: 'success'
        });
        this.countNum = 60;
        this.countDownTimer = setInterval(() => {
          this.countDown();
        }, 1000);
      }

    },
    // 倒计时
    countDown () {
      if (this.countNum < 1) {
        clearInterval(this.countDownTimer);
        this.vcodeBtnName = '重新发送';
        return;
      }
      this.countNum--;
      this.vcodeBtnName = this.countNum + '秒重发';
    },
    enterpriseIdChange (e) {
      // console.log(e)
      this.pendingList = [];
      this.formData.code = '';
      this.formData.mobile = '';
      this.formData.username = '';
      this.isPersonnel = false;
      this.isPayBtn = false;
      this.clickNum = 0;
      clearInterval(this.countDownTimer);
      this.vcodeBtnName = '获取验证码'
      this.getselectEnterpriseAdmin(e)

    },
    async getselectEnterpriseAdmin (id) {  //获取企业主
      let data = {
        enterpriseId: id
      }
      const res = await selectEnterpriseAdmin(data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      this.formData.username = res.data.username;
      this.formData.mobile = res.data.mobile;
    },
    async getlistByActivityAndEnterpriseId () {
      let data = {
        activityId: this.$route.query.id,
        enterpriseId: this.formData.enterpriseId
      }
      const res = await listByActivityAndEnterpriseId(data)
      this.pendingList = [];
      this.personnelList = [];
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      if (res && res.code == 200) {
        let list = res.data;
        let isRegisteredNum = 0;
        list.forEach((item) => {
          item['enterpriseEmployeeId'] = item.userId;
          if (item.isRegistered == '1') {
            this.pendingList.push(item)
            isRegisteredNum++
          } else {
            this.personnelList.push(item)
          }
        })
        // this.personnelList = res.data;
        this.total = list.length;
        this.isRegisteredNum = isRegisteredNum;
        this.isPersonnel = true;
        this.getlistByActivity()
      }
      // this.personnelTotal = res.t
    },
    async getlistByActivity () {
      let data = {
        activityId: this.$route.query.id,
        customerId: this.formData.enterpriseId
      }
      const res = await listByActivity(data)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      let arr = res.data;
      data.otherFee = data.otherFee ? data.otherFee : 0
      data.discountPrice = data.discountPrice ? data.discountPrice : 0
      this.userMemberCard = arr;
      this.isPayBtn = true;
    },
    async getselectMyEnterprise () {  //获取企业
      const res = await selectMyEnterprise()
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      this.enterpriseList = res.data;
    },
    async getactivityInfo (id) {   //报名详情
      const res = await activityInfo(id)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      // const regex = new RegExp('<img', 'gi');
      // res.data.description = res.data.description.replace(regex, `<img style="width: 100%;"`);
      let data = res.data;
      // data.url = data.bannerUrl;
      this.itemData = data;
    },
    async getCardList () {
      const res = await platformVip('member_level')
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      console.log(res)
      this.cardList = res.data;
      this.dqCardId = res.data[0].id
      this.itemData = res.data[0];
    },
    cardChange (e) {
      this.cardList.forEach((item) => {
        if (item.id == e) {
          this.itemData = item;
        }
      })
    },
    subPay () {
      this.clickNum++
      if (this.clickNum == 1) {
        if (this.$route.query.type == 'card') {
          buyPlatformVip({ vipId: this.itemData.id }).then(res => {
            console.log(res)
            if (res && res.code == 401) {
              this.clickNum = 0;
              this.$refs.topNav.login()
              return
            }
            if (res && res.code == 200) {
              this.getpayPlatformVip(res.data)
            } else {
              this.clickNum = 0;
            }
            // this.clickNum = 0;
          })
        } else {
          let data = this.formData
          data.activityId = this.$route.query.id;
          data.registrationDetailList = this.pendingList;
          registrationOrder(data).then(res => {
            if (res && res.code == 401) {
              this.clickNum = 0;
              this.$refs.topNav.login()
              return
            }
            if (res && res.code == 200) {
              this.getpayPlatformVip(res.data)
            } else {
              this.clickNum = 0;
            }
            // this.clickNum = 0;
          })
        }
      }
    },
    getpayPlatformVip (data) {
      console.log(data)
      if (!data.id) {
        this.$message.error(data.returnMsg)
        return false
      }
      payPlatformVip({ orderId: data.id }).then(res => {
        if (res && res.code == 401) {
          this.$refs.topNav.login()
          return
        }
        if (res && res.code == 200) {
          this.isWechatPay = true;
          this.$nextTick(() => {
            this.$refs.WechatPay.creatQrCode(res.qrcodeUrl, res.orderNo, this.type == 'card' ? 16 : 17);
          });
        } else if (res && res.code == 600) {
          this.$router.push('/Status?type=17')
        }
      })
    },
    // 订单状态关闭 15分钟超时
    orderStatusClose () {
      this.isWechatPay = false;
      this.$message.error({
        message: "订单超时, 请重新支付!",
      });
      this.clickNum = 0;
    },
    // 支付成功
    wechatPaySuccess () {
      this.isWechatPay = false;
      if (this.type == 'card') {
        this.$router.push('/Status?type=16')
      } else {
        this.$router.push('/Status?type=17')
      }
      this.clickNum = 0;
    },
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  // min-height: 100vh;
  background-color: #f5f5f5;
  .confirm_box {
    padding: 30px 0 60px 0;
    box-sizing: border-box;
    .bottom {
      margin-top: 30px;
      padding: 34px 30px;
      background-color: #fff;
      .price {
        font-family: 'bb';
        color: #de1f26;
        margin-right: 20px;
      }
    }
    .order_info {
      background-color: #fff;
      width: 100%;
      padding: 40px 30px;
      box-sizing: border-box;
      .personnel {
        width: 100%;
        margin: 20px 0;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        .content_box {
          border: 1px solid #e5e5e5;
          padding: 20px;
          .personnel_box {
            display: flex;
            flex-wrap: wrap;
            max-height: 200px;
            overflow-y: auto;
            .personnel_item {
              cursor: pointer;
              padding: 0 17px;
              height: 33px;
              line-height: 33px;
              box-sizing: border-box;
              color: #333;
              border: 1px solid #666;
              margin-right: 7px;
              margin-bottom: 7px;
            }
          }
        }
        .top {
          background-color: #f6f6f6;
          padding: 10px 20px;
          box-sizing: border-box;
          .top_title {
            flex: 1;
            font-weight: bold;
            font-size: 18px;
            color: #de1f26;
          }
          .btn {
            background-color: #de1f26;
            padding: 0 13px;
            height: 26px;
            cursor: pointer;
            line-height: 26px;
            box-sizing: border-box;
            color: #fff;
            font-size: 12px;
          }
        }
        .left {
          flex: 6;
          margin-right: 30px;
        }
        .right {
          flex: 4;
        }
      }
      .form {
        margin: 20px 0;
        .username {
          border: 1px solid #e5e5e5;
          padding: 0 22px;
          height: 40px;
          width: 85%;
          line-height: 40px;
          box-sizing: border-box;
          color: #333;
          span {
            margin-left: 11px;
          }
        }
      }
      .title {
        color: #333;
        font-weight: bold;
      }
      .info {
        margin: 20px 0 40px 0;
        .info_title {
          color: #999999;
          padding: 12px 20px;
          box-sizing: border-box;
          background-color: #f6f6f6;
        }
        .flexStart {
          border: 1px solid #e5e5e5;
          position: relative;
          .left {
            flex: 1;
            padding: 20px;
            box-sizing: border-box;
            display: flex;
            // height: 108px;
            align-items: flex-end;
            .info_box {
              width: 100%;
              padding: 20px 15px;
              border-radius: 4px;
              border: 1px solid #de1f26;
              background: #f8fafc;
              color: #666;
              font-size: 14px;
              .info_box_title {
                font-size: 16px;
                color: #333;
              }
              .emp {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                margin: 15px 0 9px 0;
              }
            }
          }
          .right {
            border-left: 1px solid #e5e5e5;
            padding: 0 40px;
            color: #de1f26;
            box-sizing: border-box;
          }
        }
      }
    }
  }
}
</style>
